export default {
  BUTTON_PRIMARY_CLASS: 'btn cm_btn--primary',
  BUTTON_SECONDARY_CLASS: 'btn cm_btn--secondary',

  TO_TEXT: '-',

  GO_TEXT: 'Go',

  CHANGE_VEHICLE: 'Change Vehicle',
  DISCARD_VEHICLE: 'Clear Selection',

  GARAGE_TITLE: 'My Garage',
  ADD_VEHICLE: 'Add New Vehicle',

  VEHICLE_SPECS_TITLE: 'Choose your trim to make sure you get the perfect fit',

  VERIFY_FITMENT_FITS: 'Fits your vehicle.',
  VERIFY_FITMENT_NOT_FIT: "Doesn't fit your vehicle.",
  VERIFY_FITMENT_AGGRESSIVE_FITS: 'Vehicle modifications may be required.',

  SEARCH_BOX_SECTION_TITLE:
    "<b>{this.totalHits > 1 ? `${this.totalHits} ` : ''}{this.sectionTitle === 'MerchandisingSuggestion' ? 'CONTENT' : this.sectionTitle}</b>{!!this.vehicleString ? ` for ${this.vehicleString}` : ''}",
};
